import module from 'module';
import _ from 'lodash';
import BigNumber from 'bignumber.js';

const templateUrl = require('./stocked-items-reprice-summary.template.html');
import './stocked-items-reprice-summary.style.less';

class StockedItemsRepriceSummary {
  constructor(http, command, notification, pawnItemStoneTypeCache, pawnItemStoneRateCache, systemPropertyCache) {
    this.http = http;
    this.command = command;
    this.notification = notification;
    this.pawnItemStoneTypeCache = pawnItemStoneTypeCache;
    this.pawnItemStoneRateCache = pawnItemStoneRateCache;
    this.systemPropertyCache = systemPropertyCache
  }

  async $onInit() {
    this.itemList = [];

    const request = this.items.map(item => {
      return {
        id: item.id,
        stoneMarkup: 0
      }
    });

    const [result, pawnItemStoneTypes, pawnItemStoneRates, systemProperties] = await Promise.all([
      this.calculateItemReprice(request),
      this.pawnItemStoneTypeCache.toPromise(),
      this.pawnItemStoneRateCache.toPromise(),
      this.systemPropertyCache.toPromise(),
    ]);

    this.pawnItemStoneTypes = pawnItemStoneTypes;
    this.pawnItemStoneRates = pawnItemStoneRates;
    this.stockedItemMarkup = Number(_.find(systemProperties, { code: 'STOCKED_ITEM_REPRICING_MARKUP_PERCENTAGE' }).value);

    this.updateView(result);
  }

  onMarkupChange(item) {
    item.newStoneValue = null;
    item.newItemValue = null;
    item.newSellingPrice = null;
  }

  async calculateNewSellingPrice() {
    let result = await this.calculateItemReprice(this.itemList);

    this.updateView(result);
  }

  canReprice() {
    return this.itemList.some(item => item.stoneMarkup === null || item.newSellingPrice === null);
  }

  async calculateItemReprice(request) {
    return await this.http.post(`/products/pawns/calculate-item-reprice`, request, { nxLoaderText: 'Calculating new prices' })
      .toPromise();
  }

  async reprice() {
    await this.command.execute('RepriceStockedItems', { stockedItems: this.itemList })
      .success(() => {
        this.cancel();
      });
  }

  cancel() {
    this.mode = null;
  }

  updateView(result) {
    for (let item of result.stockedItems) {
      const i = _.find(this.items, { id: item.id });

      if (!i) {
        continue;
      }

      item.autoDescription = i.autoDescription;
      item.categoryLabel = i.categoryLabel;
      item.typeLabel = i.typeLabel;
      item.subtypeLabel = i.subtypeLabel;

      if (item.metal.metalRateId == null) { // Bi-color or tri-color.
        item.karatLabel = "";
        item.previousGoldRateLabel = "";
        item.newGoldRateLabel = "";

        item.metal.components.forEach(metalComponent => {
          if (item.karatLabel.length) {
            item.karatLabel += ", ";
          }
          item.karatLabel += metalComponent.rate.fineness;

          if (item.previousGoldRateLabel.length) {
            item.previousGoldRateLabel += ", ";
          }

          if (metalComponent.previousMetalRate != null) {
            item.previousGoldRateLabel += metalComponent.previousMetalRate.pricePerGram.toLocaleString() + ' PHP';
          }

          if (item.newGoldRateLabel.length) {
            item.newGoldRateLabel += ", "
          }
          item.newGoldRateLabel += metalComponent.rate.pricePerGram.toLocaleString() + ' PHP';
        });

        if (!item.previousGoldRateLabel.length) {
          item.previousGoldRateLabel = '-';
        }
      } else {
        item.karatLabel = item.metal.rate.fineness;
        item.previousGoldRateLabel = item.metal.previousMetalRate != null ? item.metal.previousMetalRate.pricePerGram.toLocaleString() + ' PHP' : '-';
        item.newGoldRateLabel = item.metal.rate.pricePerGram.toLocaleString() + ' PHP';
      }

      let stoneTypes = "";
      let stoneSizes = "";
      item.stones.forEach(stone => {
        if (stoneTypes.length) {
          stoneTypes += ", ";
        }

        if (stoneSizes.length) {
          stoneSizes += ", ";
        }

        stoneTypes += _.find(this.pawnItemStoneTypes, { id: stone.stoneTypeId }).name;
        stoneSizes += _.find(this.pawnItemStoneRates, { id: stone.stoneRateId }).name;
      });

      item.stoneTypes = stoneTypes;
      item.stoneSizes = stoneSizes;
    }

    this.itemList = result.stockedItems;
  }
}

module.component('stockedItemsRepriceSummary', {
  templateUrl,
  bindings: {
    mode: '=',
    items: '<'
  },
  controller: StockedItemsRepriceSummary
});